import React, { useEffect, useRef, useState } from "react";
import html2canvas from "@wtto00/html2canvas";
import "./styles.css";
import "./sharing.css";
import { useData } from "./data/dataContext";
import { EmptyScreen } from "./validation/validation";
import useIsIOS from "./component/client";
import useIsAirbudsClient from "./component/airbudsClient";

export const ArtistImageShape = ({ className, variant, url }) => {
  const shape = (function () {
    switch (variant) {
      case 1:
        return "artist-share-shape-1";
      case 2:
        return "artist-share-shape-2";
      case 3:
        return "artist-share-shape-3";
      default:
        return "artist-share-shape-4";
    }
  })();

  const badgeShape = (function () {
    switch (variant) {
      case 1:
        return "artist-shape-badge-1";
      case 2:
        return "artist-shape-badge-2";
      case 3:
        return "artist-shape-badge-3";
      default:
        return "artist-shap-badge-4";
    }
  })();

  const badgeName = (function () {
    switch (variant) {
      case 1:
        return require("./assets/img/shape-stats-1.svg");
      case 2:
        return null;
      case 3:
        return require("./assets/img/shape-stats-3.svg");
      default:
        return require("./assets/img/shape-stats-4.svg");
    }
  })();

  return (
    <div className={className}>
      <img className={"artist-share-shape " + shape} src={url} />
      <img
        className={badgeShape}
        style={{
          right: 0,
          bottom: 0,
          position: "absolute",
        }}
        src={badgeName}
      />
    </div>
  );
};

const ShareableCard = ({ data }) => {
  var artistList = [];
  var songList = [];
  var albumList = [];
  var genre = null;

  if (data.top_artists) {
    artistList = data.top_artists ? data.top_artists.slice(0, 5) : [];
  }

  if (data.top_albums) {
    albumList = data.top_albums ? data.top_albums.slice(0, 5) : [];
  }

  if (data.top_songs) {
    songList = data.top_songs ? data.top_songs.slice(0, 5) : [];
  }

  genre = data.top_genres ? data.top_genres[0].genre : null;

  return (
    <div className="igStoriesImage">
      <div className="IgShareV2">
        <div className="top-images">
          <div className="share-top-artists-images">
            <div className="Group1812">
              <img
                className="floating-badge-3"
                src={require("./assets/img/flowerRecap.svg")}
              />

              {data && data.top_artists && data.top_artists[0] && (
                <img
                  referrerPolicy="no-referrer"
                  className="BodyBackground BodyBackground--small"
                  src={data.top_artists[0].artist_id.artwork}
                  alt="Small Circle"
                />
              )}

              {data && data.top_artists && data.top_artists[1] && (
                <img
                  referrerPolicy="no-referrer"
                  className="BodyBackground BodyBackground--medium"
                  src={data.top_artists[1].artist_id.artwork}
                  alt="Medium Circle"
                />
              )}

              {data && data.top_artists && data.top_artists[2] && (
                <img
                  referrerPolicy="no-referrer"
                  className="BodyBackground BodyBackground--tiny"
                  src={data.top_artists[2].artist_id.artwork}
                  alt="Tiny Circle"
                />
              )}

              {data && data.top_artists && data.top_artists[3] && (
                <img
                  referrerPolicy="no-referrer"
                  className="BodyBackground BodyBackground--large"
                  src={data.top_artists[3].artist_id.artwork}
                  alt="Large Circle"
                />
              )}

              {data && data.top_artists && data.top_artists[4] && (
                <img
                  referrerPolicy="no-referrer"
                  className="BodyBackground BodyBackground--xl"
                  src={data.top_artists[4].artist_id.artwork}
                  alt="XL Circle"
                />
              )}

              {data && data.top_artists && data.top_artists[5] && (
                <img
                  referrerPolicy="no-referrer"
                  className="BodyBackground BodyBackground--mediumAlt"
                  src={data.top_artists[5].artist_id.artwork}
                  alt="Medium Alternate Circle"
                />
              )}

              <img
                referrerPolicy="no-referrer"
                className="central-avatar"
                src={data.user.image}
                alt="Central Image"
              />

              <img
                className="floating-badge"
                src={require("./assets/img/shape-stats-4.svg")}
              />

              <img
                className="floating-badge-2"
                src={require("./assets/img/shape-stats-1.svg")}
              />

              <img
                src={require("./assets/img/chrome2024.png")}
                alt="Airbuds Yearly Recap"
                className="chrome2024"
              />
            </div>
          </div>
        </div>
        <div className="top-texts">
          <div className="top-lists">
            {artistList && artistList.length > 0 && (
              <div className="top-list-container top-artist-container">
                <div className="top-artist-title">Top Artists</div>
                <div className="top-list">
                  {artistList.map((item, index) => (
                    <div key={"top-line-artist-" + index} className="top-line">
                      <p>
                        {index + 1} . {item.artist_id.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {songList && songList.length > 0 && (
              <div className="top-list-container  top-songs-container">
                <div className="top-songs-title">Top Songs</div>
                <div className="top-list">
                  {songList.map((item, index) => (
                    <div key={"top-line-song-" + index} className="top-line">
                      <p>
                        {index + 1} . {item.song_id.name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="top-lists">
            {data && data.play_count && (
              <div className="top-list-container top-artist-container">
                <div className="top-artist-title">Tracks listened</div>
                <div className="top-list">
                  <div className="top-line top-line-big">
                    <p>{data && data.play_count ? data.play_count : 0}</p>
                  </div>
                </div>
              </div>
            )}

            {genre && (
              <div className="top-list-container  top-songs-container">
                <div className="top-songs-title">Top Genre</div>

                <div className="top-list">
                  <div className="top-line top-line-big">
                    <p>{genre}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="top-lists top-lists-footer">
            <div className="top-list-container top-artist-container">
              <img
                src={require("./assets/img/airbudsyearlyShare.svg")}
                alt="airbuds yearly recap"
                className="airbuds-yearly-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ShareableComponent = () => {
  const isIOS = useIsIOS();
  const { data } = useData();
  const captureRef = useRef(null);
  const containerRef = useRef(null);
  const [canvas, setCanvas] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sharing, setSharing] = useState(false);

  const close = async () => {
    webkit.messageHandlers.airbudsBridge.postMessage('{"close": {}}');
  };

  useEffect(() => {
    // declare the data fetching function
    const computeImage = async () => {
      setLoading(true);

      var options = {};
      if (isIOS) {
        options = {
          scale: 1,
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
        };
      } else {
        options = {
          scale: 1,
          useCORS: true,
          allowTaint: true,
        };
      }
      const c = await html2canvas(captureRef.current, options);

      setCanvas(c.toDataURL(isIOS ? "image/png" : "image/jpg"));
      setLoading(false);
    };

    // call the function
    computeImage()
      // make sure to catch any error
      .catch(console.error);
  }, [data, isIOS]);

  if (!data) {
    return <EmptyScreen text="loading..." />;
  }

  const handleCapture = async () => {
    if (typeof webkit === "undefined") {
      if (navigator.share) {
        const response = await fetch(canvas);
        const blob = await response.blob();
        // Convert dataURL to Blob
        try {
          await navigator.share({
            files: [new File([blob], "music-recap.png", { type: blob.type })],
          });
        } catch (error) {
          console.error("Error sharing:", error);
        }
      } else {
        alert("Sharing is not supported in your browser!");
      }
    } else {
      const base64Img = canvas.split(",")[1];

      // to receive messages from native
      window.airbudsMessage = function (data) {};

      webkit.messageHandlers.airbudsBridge.postMessage(
        '{"share": {"editable":true,"image": "' + base64Img + '"}}'
      );
    }
    setSharing(false);
  };

  return (
    <div className="app">
      <div className="content sharing-content">
        {canvas && <img className="recap-image" src={canvas} />}

        {!canvas && (
          <div className="sharingCardContainer" ref={containerRef}>
            {!canvas && (
              <div className="imageOverlay">
                <EmptyScreen text={"loading your card..."} />
              </div>
            )}

            {!canvas && (
              <div
                ref={captureRef}
                className={isIOS ? "sharingCard" : "sharingCardBackground"}
              >
                <ShareableCard data={data} />
              </div>
            )}
          </div>
        )}

        <div className="sharing-actions">
          {!sharing && (
            <button
              className="big-cta-button"
              onClick={() => {
                setSharing(true);
                setTimeout(() => {
                  handleCapture();
                }, 500);
              }}
            >
              Share your recap
            </button>
          )}

          {sharing && <p>Prepare for sharing...</p>}
        </div>
      </div>
    </div>
  );
};

export default ShareableComponent;
